import React from 'react'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { FundingBannerForm } from './components/FundingBannerForm'
import { FundingBannerInfo } from './components/FundingBannerInfo'
import { FundingBannerLogos } from './components/FundingBannerLogos'
import type { TFundingBannerConsultingFormProps } from './types'
import './styles.scss'

export const FundingBannerStepForm = (props: TFundingBannerConsultingFormProps) => {
  const { phoneNumber, onOpenLoginDialog, onCloseLoginDialog, onOpenRegistrationForm, onSendRequest } = props

  const { isDesktop } = useDeviceType()

  return (
    <div className="fundingBannerStepForm">
      <FundingBannerInfo />
      <FundingBannerForm
        phoneNumber={phoneNumber}
        onOpenLoginDialog={onOpenLoginDialog}
        onCloseLoginDialog={onCloseLoginDialog}
        onOpenRegistrationForm={onOpenRegistrationForm}
        onSendRequest={onSendRequest}
      />

      {!isDesktop && <FundingBannerLogos />}
    </div>
  )
}
